import { render, staticRenderFns } from "./EditProfileTab.vue?vue&type=template&id=ef791170&scoped=true&"
import script from "./EditProfileTab.vue?vue&type=script&lang=js&"
export * from "./EditProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./EditProfileTab.vue?vue&type=style&index=0&id=ef791170&scoped=true&lang=css&"
import style1 from "./EditProfileTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef791170",
  null
  
)

export default component.exports